import { library } from '@fortawesome/fontawesome-svg-core';
import { faThumbsUp, faUsers, faHandshake, faEarthAmericas, } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

library.add(faUsers, faThumbsUp, faHandshake, faEarthAmericas)

const Summary = () => {
    const summaries = [
        { number: '302+', name: 'Happy Clients', icon: 'fa-users', more: 'Full time clients with over 10 years of happy business' },
        { number: '10,000+', name: 'Parts Sold Every Year', icon: 'fa-handshake', more: 'Selling top quality bike products for 25 years' },
        { number: '1,002+', name: 'Positive Reviews', icon: 'fa-thumbs-up', more: 'Loved all over the world in global ratings and reviews' },
        { number: '30+', name: 'Countries With Happy Clients', icon: 'fa-earth-americas', more: 'Providing the best product to 34 countries in the world' }
    ]
    return (
        <div className='my-32 lg:h-80'>
            <h2 className='text-3xl font-semibold text-center'>Maintaining Quality Worldwide</h2>
            <div className='grid grid-cols-2 lg:grid-cols-4 gap-5 mx-4 md:mx-10 my-16 justify-center items-center cursor-pointer h-full'>
                {
                    summaries.map((summary, i) => <div key={i} className="card h-full bg-transparent static border transition-all lg:h-fit lg:hover:-translate-y-4 lg:hover:bg-secondary text-center">
                        <div className="group card-body items-center px-1 md:px-4">
                            <FontAwesomeIcon icon={summary.icon} className='h-10 md:h-16 my-2 text-primary transition-all duration-500 lg:group-hover:scale-125 lg:group-hover:text-primary-focus' />
                            <h2 className="card-title md:text-3xl lg:group-hover:text-gray-800">{summary.number}</h2>
                            <h2 className="text-sm md:text-2xl md:whitespace-nowrap font-bold lg:group-hover:text-gray-800">{summary.name}</h2>
                            <h2 className="text-xs md:text-lg text-center font-semibold lg:hidden lg:group-hover:inline-block lg:group-hover:text-gray-800">{summary.more}</h2>
                        </div>
                    </div>)
                }
            </div>
        </div>

    );
};

export default Summary;